export const CommunicationTypes = {
  ICommunicationService: Symbol("ICommunicationService"),
};
